export default {
  'landing.memory': 'Make your memories with us',
  'landing.family': 'Experience the best trips with your family and friends',
  'landing.providing':
    'Providing all flights and the easiest process of searching, buying and refunding air tickets',
  'landing.price':
    'The lowest price to buy plane tickets with a special discount',
  'landing.point': 'Earn points with every trip',
  'landing.buynow': 'Buy Now',
  'landing.scotland': 'Travel to Scotland',
  'landing.ireland': 'Travel to Irland',
  'landing.egypt': 'Travel to Egypt',
  'landing.greece': 'Travel to Greece',
  'landing.person': 'some people have gone',
  'landing.categories': 'Categories',
};
